
import { ControlElement } from '@jsonforms/core';
import { defineComponent } from 'vue';
import { rendererProps, useJsonFormsControl, RendererProps } from '@jsonforms/vue';
import emitter from 'tiny-emitter/instance';

const controlRenderer = defineComponent({
  name: 'string-control-renderer',
  components: {},
  props: {
    ...rendererProps<ControlElement>(),
    itemLabel: {
      type: String,
    },
  },
  data() {
    return {
      disable: false,
      isTouched: false,
    };
  },
  mounted() {
    if (
      this.control?.data?.length &&
      !this.control?.uischema?.options?.editable &&
      !this.control?.config?.editableHydratedFields
    ) {
      this.disable = true;
    }
    // Don't call onChange here to avoid triggering validation on mount
    // this.onChange(this.control.data);
  },
  methods: {
    onBlur() {
      this.isTouched = true;
    },
    onFocus() {
      // Optionally mark as touched on focus as well
      // this.isTouched = true;
    },
    onChange(value: any) {
      // Mark as touched when user changes the value
      this.isTouched = true;
      
      if (this.control?.uischema?.options?.toUppercase) {
        this.handleChange(this.control.path, value ? value.toUpperCase() : undefined);
      } else {
        this.handleChange(this.control.path, value && value.length ? value : undefined);
      }
    },
  },
  computed: {
    computedErrors() {
      return this.control.errors;
    },
  },
  created() {
    emitter.on('setDestinationApmId', (apmId: string) => {
      if (this.control?.uischema?.options?.key === 'destinationApmId') {
        this.isTouched = true;
        this.onChange(apmId);
      }
    });
    emitter.on('setSourceApmId', (apmId: string) => {
      if (this.control?.uischema?.options?.key === 'sourceApmId') {
        this.isTouched = true;
        this.onChange(apmId);
      }
    });
    emitter.on('setSource', (ip: string) => {
      if (this.control?.uischema?.options?.key === 'source') {
        this.isTouched = true;
        this.onChange(ip);
      }
    });
    emitter.on('setDestination', (ip: string) => {
      if (this.control?.uischema?.options?.key === 'destination') {
        this.isTouched = true;
        this.onChange(ip);
      }
    });
    emitter.on('setDestinationName', (data: string | undefined) => {
      if (this.control?.uischema?.options?.key === 'destinationName') {
        this.onChange(data);
      }
    });
    emitter.on('setDestinationEnv', (data: string | undefined) => {
      if (this.control?.uischema?.options?.key === 'destinationEnv') {
        this.onChange(data);
      }
    });
    emitter.on('setSourceName', (data: string | undefined) => {
      if (this.control?.uischema?.options?.key === 'sourceName') {
        this.onChange(data);
      }
    });
    emitter.on('setSourceEnv', (data: string | undefined) => {
      if (this.control?.uischema?.options?.key === 'sourceEnv') {
        this.onChange(data);
      }
    });
    emitter.on('setPort', (data: string | undefined) => {
      if (this.control?.uischema?.options?.key === 'port') {
        this.onChange(data);
      }
    });
  },
  setup(props: RendererProps<ControlElement>) {
    return useJsonFormsControl(props);
  },
});

export default controlRenderer;
